import axios from "axios";
import {
  GET_CHAT_BY_ID_FAIL,
  GET_CHAT_BY_ID_REQUEST,
  GET_CHAT_BY_ID_SUCCESS,
  GET_MESSAGES_FAIL,
  GET_MESSAGES_REQUEST,
  GET_MESSAGES_SUCCESS,
  SEND_MESSAGE_FAIL,
  SEND_MESSAGE_REQUEST,
  SEND_MESSAGE_SUCCESS,
  USER_GET_ALL_CHATS_FAIL,
  USER_GET_ALL_CHATS_REQUEST,
  USER_GET_ALL_CHATS_SUCCESS,
} from "../constants/msgConstants";

export const createCon = async (token, data) =>
  await axios.post(`/api/create-con`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getAllChats = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_GET_ALL_CHATS_REQUEST,
    });

    const { auth } = getState((state) => ({ ...state }));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth.token}`,
      },
    };

    const { data } = await axios.get(`/api/conversations`, config);

    dispatch({
      type: USER_GET_ALL_CHATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: USER_GET_ALL_CHATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getChatById = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CHAT_BY_ID_REQUEST,
    });

    const { auth } = getState((state) => ({ ...state }));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth.token}`,
      },
    };

    const { data } = await axios.get(`/api/conversation/${id}`, config);

    dispatch({
      type: GET_CHAT_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CHAT_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getMessages = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_MESSAGES_REQUEST,
    });

    const { auth } = getState((state) => ({ ...state }));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth.token}`,
      },
    };

    const { data } = await axios.get(`/api/messages/${id}`, config);

    dispatch({
      type: GET_MESSAGES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_MESSAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendMessage =
  (body, to, id, date, type, conversations) => async (dispatch, getState) => {
    try {
      dispatch({
        type: SEND_MESSAGE_REQUEST,
      });

      const { auth } = getState((state) => ({ ...state }));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.token}`,
        },
      };

      const { data } = await axios.post(
        `/api/send`,
        { to, body, id, date, type },
        config
      );

      dispatch({
        type: SEND_MESSAGE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SEND_MESSAGE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
